/**
 * Google reCAPTCHA v2 ("I'm not a robot"), loaded from Google on the login
 * page only — never bundled, and never on the customer's order page.
 */
const SCRIPT_URL = 'https://www.google.com/recaptcha/api.js?render=explicit'

let loading = null

/** Resolves with window.grecaptcha once Google's script is ready. */
export function loadRecaptcha() {
  if (loading) return loading
  loading = new Promise((resolve, reject) => {
    if (window.grecaptcha?.render) {
      window.grecaptcha.ready(() => resolve(window.grecaptcha))
      return
    }
    const script = document.createElement('script')
    script.src = SCRIPT_URL
    script.async = true
    script.defer = true
    script.onload = () => window.grecaptcha.ready(() => resolve(window.grecaptcha))
    script.onerror = () => {
      loading = null                     // a later visit to the page tries again
      reject(new Error('reCAPTCHA could not load'))
    }
    document.head.appendChild(script)
  })
  return loading
}
